import { defaultReturn, generateDefaultActions, makeWritePayload } from "shared-utility/store/utils/helpers";

export const SET_DEBT_YIELD_CALC_SELECTIONS = generateDefaultActions("SET_DEBT_YIELD_CALC_SELECTIONS");
export const setDebtYieldCalculationDashboardSelections = payload => makeWritePayload(SET_DEBT_YIELD_CALC_SELECTIONS.value, payload);

export const actionCreators = {
  setDebtYieldCalculationDashboardSelections
};

const initialState = {
  isDeleteDialogOpen: false,
  isLenderReportingDrawerOpen: false,
  initialDrawerSectionName: null
};

export function lenderReportsDebtYieldCalculationReducer(state = initialState, action) {
  const { type, payload } = action;

  if(type === SET_DEBT_YIELD_CALC_SELECTIONS.value){
    return defaultReturn({ ...state, ...payload });
  }
  return state;
};

